// ============================================================
// TOAST NOTIFICATION SINGLETON — imported by module-level components
// ============================================================
let _toastHandler = null;

export const toast = (message, type = 'success') => {
  if (_toastHandler) _toastHandler(message, type);
};

export const registerToastHandler = (handler) => {
  _toastHandler = handler;
};

export const unregisterToastHandler = () => {
  _toastHandler = null;
};
